/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {ConnectToAccessPointRequest} from "../model/connect-to-access-point-request";
import {ConnectToAccessPointWithProfileRequest} from "../model/connect-to-access-point-with-profile-request";
import {RemoveAccessPointProfileRequest} from "../model/remove-access-point-profile-request";
import {SuccessResponse} from "../model/success-response";
import {WifiAccessPointResponse} from "../model/wifi-access-point-response";
import {WifiStatus} from "../model/wifi-status";

@Injectable({
    providedIn: "root",
})
export class SimWifiService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public connectToAccessPoint(request: ConnectToAccessPointRequest) {
        return super.post<SuccessResponse>(`/api/Wifi/ConnectToAccessPoint`, request);
    }

    public connectToAccessPointWithProfile(request: ConnectToAccessPointWithProfileRequest) {
        return super.post<SuccessResponse>(`/api/Wifi/ConnectToAccessPointWithProfile`, request);
    }

    public disconnect() {
        return super.post<void>(`/api/Wifi/Disconnect`, {});
    }

    public getAccessPoints() {
        return super.get<WifiAccessPointResponse[]>(`/api/Wifi/GetAccessPoints`, );
    }

    public getProfile(accessPointName: string) {
        return super.get<string>(`/api/Wifi/GetProfile`, {accessPointName: accessPointName});
    }

    public getStatus() {
        return super.get<WifiStatus>(`/api/Wifi/GetStatus`, );
    }

    public removeProfile(request: RemoveAccessPointProfileRequest) {
        return super.post<SuccessResponse>(`/api/Wifi/RemoveProfile`, request);
    }
}